import { Component } from "react";

class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    console.error("App error:", error);
  }

  render() {
    if (this.state.hasError) {
      return (
        <div className="flex min-h-screen flex-col items-center justify-center gap-4 px-6 text-center">
          <p className="text-2xl font-bold text-slate-900">Noget gik desværre galt</p>
          <p className="text-slate-600">Prøv at genindlæse siden.</p>
          <button
            onClick={() => window.location.reload()}
            className="rounded-full bg-brand-950 px-6 py-3 text-sm font-semibold text-white"
          >
            Genindlæs
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

export default ErrorBoundary;